import React from 'react';
import PropTypes from 'prop-types';
import RocketSvg from './rocket.svg';
import { Button } from '../../Button';
import './FreelancerSelectedOnePopup.css';

export const FreelancerSelectedOnePopup = ({
  handleContinue,
  handleSelectMoreFreelancers,
}) => (
  <div className="freelancer-selected-one-poppup">
    <img
      alt="header"
      className="freelancer-selected-one-poppup__header"
      src={RocketSvg}
    />
    <div className="freelancer-selected-one-poppup__title">Ready To Go?</div>
    <div className="freelancer-selected-one-poppup__description">
      You&apos;ve selected one freelancer for your project, if you&apos;re ready
      to go
      <br />
      click continue and we&apos;ll get started on your project right away.
    </div>
    <div className="freelancer-selected-one-poppup__action">
      <Button
        className="freelancer-selected-one-poppup__action--continue"
        rounded
        title="Continue"
        onClick={handleContinue}
      />
      <Button
        className="freelancer-selected-one-poppup__action--select-more-freelancers"
        textClassName="freelancer-selected-one-poppup__action--select-more-freelancers-text"
        transparent
        title="I'd like to select more freelancers"
        withoutTextTransform
        onClick={handleSelectMoreFreelancers}
      />
    </div>
  </div>
);

FreelancerSelectedOnePopup.propTypes = {
  handleContinue: PropTypes.func,
  handleSelectMoreFreelancers: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/FreelancerSelectedOnePopup/FreelancerSelectedOnePopup.js